export default __webpack_public_path__ + "static/media/visibility.11bf3055.svg";